import React from 'react'
import LandingHeader from './LandingHeader'
import Contact from './Contact'
import Footer from './Footer'

const ContactPage = () => {
 
  return (
    <div>
        <LandingHeader/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default ContactPage